import {useEffect, useRef, useState} from 'react';
import useBasket from '../../../../hooks/use-basket/use-basket';
import Image from '../../../atoms/Image/Image';
import BuyNowButton from '../../Buttons/BuyNow/BuyNowButton';
import StyledCtaSticky, {StyledPrice, StyledTitle} from './styles';
import Props from './typings';

const CtaSticky = ({product, title, img, currency, show = false, holiday = false}: Props) => {
  const basket = useBasket();
  const rendered = useRef(false);
  const [displayStyle, setDisplayStyle] = useState('none');
  const [showBar, setShowBar] = useState(show);
  const isInBasket = () => basket.contains(product);

  useEffect(() => {
    if (!rendered.current) return;

    if (isInBasket()) {
      setShowBar(false);
      setTimeout(() => {
        setDisplayStyle('none');
      }, 100);
    }
  }, [isInBasket()]);

  useEffect(() => {
    if (isInBasket()) return;

    if (show) {
      setShowBar(true);
      setDisplayStyle('flex');
    } else if (!show && rendered.current) {
      setShowBar(false);
      setTimeout(() => {
        setDisplayStyle('none');
      }, 100);
    }

    if (!rendered.current) rendered.current = true;
  }, [show]);

  return (
    <>
      {product?.is_in_stock && !holiday && (
        <StyledCtaSticky $show={showBar} $displayStyle={displayStyle}>
          <Image
            path={img}
            alt={`${product.name} by ${product.artist_name}`}
            mainColor={product.average_colour}
            width={54}
            height={54}
          />

          <section>
            <StyledTitle>{title}</StyledTitle>

            <StyledPrice>{product.pricing[currency].current_price}</StyledPrice>
          </section>

          <BuyNowButton currency={currency} product={product} />
        </StyledCtaSticky>
      )}
    </>
  );
};

export default CtaSticky;
